// extracted by mini-css-extract-plugin
export var list = "events-list-module--list--gmpid";